module.exports = require("/Volumes/DATA/projects/slipway-ah-pluskarla/.gatsby/gatsby-browser.ts");